export interface IPageProps {
  loading: boolean;
  authenticated: boolean;
}

export enum EBuildType {
  BROWSER = "browser",
  ELECTRON = "electron",
}
